import * as React from 'react';
import List from '../components/List';

const MENU_KEY = 'confirm_quote';

export default class ConfirmQuote extends React.Component<any, any> {
  public render() {
    return <List menuKey={MENU_KEY} {...this.props}/>;
  }
}
